import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  dashboardData: [],
};

export const fetchDashboardData = createAsyncThunk(
  "fetchDashboardData/dashboardData",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`dashboard-data`);
      return {
        data: response.data,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  },
);

const dashboardDataSlice = createSlice({
  name: "dashboardData",
  initialState,
  extraReducers: (builder) => {
    // ==========================

    // TODO: fetch category
    builder.addCase(fetchDashboardData.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchDashboardData.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.dashboardData = action.payload;
    });

    builder.addCase(fetchDashboardData.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default dashboardDataSlice.reducer;
